import { render } from "./History.vue?vue&type=template&id=dfab7d92&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=dfab7d92&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2362541812/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfab7d92"]])

export default __exports__